import React from "react";
import { Box, BoxProps, SxProps, Theme } from "@mui/material";

interface CustomBoxProps extends BoxProps {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
  backgroundColor?: string;
  border?: string;
  borderRadius?: string | number;
  p?: number | string;
  gap?: number | string;
}

const CustomBox: React.FC<CustomBoxProps> = ({
  children,
  sx,
  backgroundColor = "#46464644",
  border = "1px solid #474747ff",
  borderRadius = "11px",
  p = 3,
  gap = 2,
  ...props
}) => {
  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor,
        border,
        borderRadius,
        p,
        gap,
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        overflow: "hidden",
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export default CustomBox;
